// ACTIONS TYPES
export const SET_CONDITIONS = "setConditions";
export const RESET_CONDITIONS = "resetConditions";

// Mutations Types
const SET_CONDITIONS_MUTATION = "setConditions";
const RESET_CONDITIONS_MUTATION = "resetConditions";

const state = {
  conditions: {
    agents: [],
    channels: [],
    statuses: [],
    campaigns: [],
    applicationDates: [],
    assignmentDates: [],
    callResultCodes: [],
  },
};

const mutations = {
  [SET_CONDITIONS_MUTATION](state, payload) {
    state.conditions = payload;
  },
  [RESET_CONDITIONS_MUTATION](state) {
    state.conditions = {
      agents: [],
      channels: [],
      statuses: [],
      campaigns: [],
      applicationDates: [],
      assignmentDates: [],
      callResultCodes: [],
    };
  },
};

const actions = {
  [SET_CONDITIONS]({ commit }, payload) {
    commit(SET_CONDITIONS_MUTATION, payload);
  },
  [RESET_CONDITIONS]({ commit }) {
    commit(RESET_CONDITIONS_MUTATION);
  },
};

const getters = {
  conditions: (state) => state.conditions,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
